<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item v-if="quotation" :to="parentRouter.path">{{
        parentRouter.name
      }}</el-breadcrumb-item>
      <el-breadcrumb-item>报价单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <template v-if="quotation">
      <div class="panel mt-20">
        <div class="order-option-header mb-15">
          <h6 style="display: flex; align-items: center">
            报价单号 {{ quotation.number }}
            <el-tag
              v-if="!quotation.deleted"
              size="small"
              class="ml-10"
              :type="quotationStatusMap[quotation.status].type"
              >{{ quotationStatusMap[quotation.status].name }}</el-tag
            >
          </h6>
          <div>
            <div>
              <template v-if="canEdit"
                ><router-link
                  style="margin-right: 10px"
                  :to="'/dashboard/new_quotation?quotation=' + quotation.id"
                  v-permission="Auth.quotationEdit"
                >
                  <el-button
                    icon="el-icon-edit"
                    size="mini"
                    type="primary"
                    plain
                    >编辑</el-button
                  >
                </router-link>
                <el-button
                  icon="el-icon-delete"
                  size="mini"
                  type="danger"
                  plain
                  @click="deleteQuotation()"
                  v-permission="Auth.quotationDelete"
                  >删除</el-button
                ></template
              >
              <el-button
                v-if="quotation.deleted == 1"
                icon="el-icon-delete"
                size="mini"
                type="success"
                plain
                @click="recoveryQuotation()"
                v-permission="Auth.quotationRecovery"
                >恢复</el-button
              >
              <template v-if="!quotation.deleted">
                <el-button
                  v-if="canSubmitApproval"
                  icon="el-icon-check"
                  size="mini"
                  type="primary"
                  @click="submitApproval()"
                  v-permission="Auth.quotationNew"
                  >提交审核</el-button
                >
                <el-button
                  v-if="canOrder"
                  icon="el-icon-check"
                  size="mini"
                  type="primary"
                  @click="convertOrder()"
                  v-permission="Auth.quotationNew"
                  >转成订单</el-button
                >
                <el-button
                  v-if="!isMobile()"
                  icon="el-icon-printer"
                  size="mini"
                  type="primary"
                  plain
                  @click="quotationPreviewVisibile = true"
                  >预览</el-button
                >
              </template>
            </div>
          </div>
        </div>
        <el-form label-position="right" size="mini" label-width="100px">
          <el-form-item label="金额：">
            <div class="text-danger font-weight-bolder font-14">
              ￥{{ math.show(quotation.order_info.amount) }}
            </div>
          </el-form-item>
          <el-form-item label="创建人：">
            {{ quotation.user.name }}
          </el-form-item>
          <el-form-item label="创建时间：">
            <div>
              {{
                $time(new Date(quotation.created_at)).format('YYYY-MM-DD HH:mm')
              }}
            </div>
          </el-form-item>
          <el-form-item label="客户名称：">
            <customer-link :customer="quotation.customer"></customer-link>
          </el-form-item>
          <el-form-item label="项目名称：">
            {{ quotation.order_info.project_name }}
          </el-form-item>
          <el-form-item
            label="联系人："
            v-if="quotation.order_info.customer_contact_id > 0"
          >
            {{ quotation.order_info.customer_contact.name }}
            {{ quotation.order_info.customer_contact.mobile }}
          </el-form-item>
          <el-form-item label="收货信息：">
            <div class="receive-info">
              <span class="mr-20">{{
                showParam(quotation.order_info.consignee_name)
              }}</span
              ><span class="mr-20">{{
                showParam(quotation.order_info.shipping_address)
              }}</span
              ><span class="mr-20">
                {{ showParam(quotation.order_info.consignee_mobile) }}
              </span>
            </div>
          </el-form-item>
          <el-form-item label="发票信息：">
            <div class="receive-info">
              {{ showParam(quotation.order_info.invoice.title) }}
            </div>
          </el-form-item>
          <el-form-item label="补充信息：" v-if="quotation.order_info.remark">
            <div class="ql-remark-display">
              <div class="ql-editor" v-html="quotation.order_info.remark"></div>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="panel mt-20" v-if="quotation && quotation.flow_id">
        <p>{{ quotation.status == 1 ? '审批流程（预览）' : '审批流程' }}</p>
        <div class="mb-20">
          <div class="mt-10" :class="{ 'flex-row-between': !isMobile() }">
            <el-steps
              v-if="quotation.approvers"
              simple
              :active="quotation.status == 1 ? -1 : quotation.approve_index"
              finish-status="success"
              :style="'width:' + quotation.approvers.length * 160 + 'px'"
            >
              <el-step
                v-for="(user, index) in quotation.approver_names"
                :key="index"
                :title="user"
                :status="
                  quotation.status == 3 && index + 1 == quotation.approve_index
                    ? 'error'
                    : ''
                "
              ></el-step>
            </el-steps>
          </div>
        </div>
        <el-button
          v-if="canApproval"
          icon="el-icon-check"
          size="small"
          type="primary"
          @click="submitApprovalResult(true)"
          v-permission="Auth.quotationApprove"
          >审批通过</el-button
        >
        <el-button
          v-if="canApproval"
          icon="el-icon-close"
          size="small"
          type="danger"
          @click="submitApprovalResult(false)"
          v-permission="Auth.quotationApprove"
          >不通过</el-button
        >
      </div>

      <div class="panel mt-20" v-if="quotation.order_info.products.length > 0">
        <div class="header">
          <h2>产品</h2>
        </div>
        <el-table
          v-if="!isMobile()"
          :data="quotation.order_info.products"
          style="width: 100%"
          key="order_info.products"
        >
          <el-table-column prop="name" label="件号/类型">
            <template slot-scope="scope">
              <div>
                {{ scope.row.item.part_number }}
              </div>
              <div>
                {{ scope.row.item.commodity_category.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="item.description" label="描述">
          </el-table-column>
          <!-- <el-table-column prop="item.name" label="产品"></el-table-column>
              <el-table-column
                prop="item.part_number"
                label="件号"
                width="120"
              ></el-table-column> -->
          <el-table-column prop="price" label="价格(￥)" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.price }}</div>
              <div class="price-info">
                <span>
                  原价：{{ scope.row.item.price }} (
                  {{
                    priceIncreasePercent(scope.row.item.price, scope.row.price)
                  }}%)
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="count"
            label="数量"
            width="80"
            align="center"
          ></el-table-column>
        </el-table>
        <item-list-mobile
          v-else
          :items="quotation.order_info.products"
        ></item-list-mobile>

        <div class="header mt-20">
          <h2>结算</h2>
        </div>
        <div class="settle mt-20">
          <ul class="fee-list">
            <li>
              <div class="title">小计</div>
              <div class="input"></div>
              <div class="symbol"></div>
              <div class="amount">{{ math.show(displayFee.item) }}</div>
            </li>
            <li>
              <div class="title">税费（13%）</div>
              <div class="input"></div>
              <div class="symbol">+</div>
              <div class="amount">{{ math.show(displayFee.tax) }}</div>
            </li>
            <li>
              <div class="title">杂项</div>
              <div class="input"></div>
              <div class="symbol">+</div>
              <div class="amount">{{ math.show(displayFee.labor) }}</div>
            </li>
            <li>
              <div class="title">折扣金额（含税）</div>
              <div class="input text-info-12">
                约{{ math.show(displayFee.discount) }}%
              </div>
              <div class="symbol">-</div>
              <div class="amount">
                {{ math.show(displayFee.discount_value) }}
              </div>
            </li>
            <li>
              <div class="title">合计</div>
              <div class="input"></div>
              <div class="amount">
                {{ math.show(quotation.order_info.amount) }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <el-row :gutter="24">
        <!-- <el-col :span="14">
          <div class="panel mt-20">
            <div class="header flex-row-between">
              <h2>成本</h2>
            </div>
            <ul class="other-infos">
              <li class="sub-info">
                <span class="sub-info-label">产品成本</span>
                <span class="sub-info-value">
                  {{ quotation.order_info.item_cost.toFixed(2) }}
                </span>
              </li>
              <li class="sub-info">
                <span class="sub-info-label">预计安装成本</span>
                <span class="sub-info-value">
                  {{ quotation.order_info.install_cost.toFixed(2) }}
                </span>
              </li>
              <li class="sub-info">
                <span class="sub-info-label">预计其他成本</span>
                <span class="sub-info-value">
                  {{ quotation.order_info.other_cost.toFixed(2) }}
                </span>
              </li>
            </ul>
          </div>
          <div class="panel mt-20">
            <div class="header">
              <h2>结算</h2>
            </div>
            <ul class="fee-list">
              <li>
                <div class="title">小计</div>
                <div class="input"></div>
                <div class="symbol"></div>
                <div class="amount">{{ math.show(displayFee.item) }}</div>
              </li>
              <li>
                <div class="title">税费（13%）</div>
                <div class="input"></div>
                <div class="symbol">+</div>
                <div class="amount">{{ math.show(displayFee.tax) }}</div>
              </li>
              <li>
                <div class="title">杂项</div>
                <div class="input"></div>
                <div class="symbol">+</div>
                <div class="amount">{{ math.show(displayFee.labor) }}</div>
              </li>
              <li>
                <div class="title">折扣金额（含税）</div>
                <div class="input text-info-12">
                  约{{ math.show(displayFee.discount) }}%
                </div>
                <div class="symbol">-</div>
                <div class="amount">
                  {{ math.show(displayFee.discount_value) }}
                </div>
              </li>
              <li>
                <div class="title">合计</div>
                <div class="input"></div>
                <div class="amount">
                  {{ math.show(quotation.order_info.amount) }}
                </div>
              </li>
            </ul>
            <div class="estimate-profit" v-if="quotation.flow_id > 0">
              <template>
                <div v-if="quotation.flow_id > 0">
                  审批流程：{{ quotation.flow_name }}
                  <span class="text-gray"
                    >（<span v-html="quotation.approver_names_html"></span
                    >）</span
                  >
                </div>
                <div v-else-if="orderInfoFlow && orderInfoFlow.flow.id > 0">
                  审批流程：{{ orderInfoFlow.flow.name }}
                  <span class="text-gray">
                    （
                    <span v-html="orderInfoFlow.users"></span>）
                  </span>
                </div>
              </template>
            </div>
          </div>
        </el-col> -->
        <el-col :span="24">
          <div class="panel mt-20">
            <div class="header">
              <h2>版本记录</h2>
            </div>
            <ul class="versions" v-if="quotation.versions.length > 0">
              <li
                class="flex-row-between"
                v-for="(v, i) in quotation.versions"
                @click="openQuotationVerions(i)"
              >
                <span class="text-primary pointer">v{{ i + 1 }}</span>
                <span class="text-gray">{{
                  formatTime(v.created_at, 'YYYY-MM-DD HH:mm')
                }}</span>
              </li>
            </ul>
            <div class="text-info-12" v-else>暂无版本信息。</div>
          </div>
        </el-col>
      </el-row>
      <quotation-preview
        :show.sync="quotationPreviewVisibile"
        :quotation="quotation"
        :print="true"
        :fee="displayFee"
      ></quotation-preview>
      <flow-selector
        :show.sync="flowSelectorVisibile"
        @selected="selectedFlow"
      ></flow-selector>
      <quotation-version
        :show.sync="quotationVersionVisible"
        :quotation="quotation"
        :versions="versions"
        :index="quotationVersionIndex"
      ></quotation-version>
    </template>
  </div>
</template>

<script>
import {
  quotationDetail,
  updateQuotaionStatus,
  deleteQuotation,
  itemDetail,
  itemCostPrice,
  approveQuotation,
  submitApproveQuotation,
  convertQuotation,
  recoveryCustomer,
  recoveryQuotation,
} from '../../service/getData'
import { numberMul, formatTime, priceIncreasePercent } from '@/util/index'
import math from '@/util/math'
import { QuotationStatusMap } from '@/config/global'
import store from '@/store/store'
import QuotationPreview from '@/components/quotation_preview'
import FlowSelector from '@/components/flow_selector'
import { CodeToText } from '@/util/area_tool'
import auth from '@/util/auth'
import QuotationVersion from '@/components/quotation_version'
import {
  DisplayOrderFee,
  CalculateProfit,
  AutoOrderInfoFlow,
} from '@/util/order_calculate'
import { isMobile, clone } from '../../util'
import ItemListMobile from './item_list_mobile'

export default {
  components: {
    QuotationPreview,
    FlowSelector,
    QuotationVersion,
    ItemListMobile,
  },
  data() {
    return {
      isMobile,
      profit: '计算中…',
      profit_rate: 0,
      previwerVisbile: false,
      id: parseInt(this.$route.params.id),
      quotation: null,
      numberMul: numberMul,
      quotationStatusMap: QuotationStatusMap,
      quotationVersionVisible: false,
      formatTime: formatTime,
      userInfo: store.getters.userInfo,
      quotationPreviewVisibile: false,
      CodeToText,
      itemCostPrices: [],
      math,
      orderInfoFlow: null,
      quotationVersionIndex: 0,
      priceIncreasePercent,
      flowSelectorVisibile: false,
      displayFee: {
        item: 0,
        tax: 0,
        labor: 0,
        discount: 0,
        total: 0,
      },
      versions: [],
      uploadConfig: {
        action: '', // 必填参数 图片上传地址
        methods: 'POST', // 必填参数 图片上传方式
        token: sessionStorage.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        name: 'img', // 必填参数 文件的参数名
        size: 500, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon', // 可选 可上传的图片格式
      },
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (parseInt(to.params.id) != this.id) {
      this.id = parseInt(to.params.id)
      setTimeout(this.ready, 50)
    }
    next()
  },
  created() {
    this.ready()
  },
  computed: {
    canEdit() {
      return (
        this.quotation.deleted == 0 &&
        this.quotation.status != 2 &&
        this.quotation.status != 5 &&
        this.quotation.status != 6 &&
        this.quotation.user_id == this.userInfo.id
      )
    },
    canSubmitApproval() {
      return (
        (this.quotation.status == 1 || this.quotation.status == 3) &&
        this.quotation.user_id == this.userInfo.id
      )
    },
    canApproval() {
      return (
        this.quotation.status == 2 &&
        this.quotation.flow_id > 0 &&
        this.quotation.approvers[this.quotation.approve_index] ==
          this.userInfo.id
      )
    },
    canOrder() {
      return (
        this.quotation.status == 6 && this.quotation.user_id == this.userInfo.id
      )
    },
    customerAddress() {
      let customer = this.quotation.customer
      return (
        CodeToText[customer.province] +
        CodeToText[customer.city] +
        CodeToText[customer.county] +
        customer.address_detail
      )
    },
    parentRouter() {
      if (this.quotation.deleted == 1) {
        return {
          path: '/dashboard/deleted/quotations',
          name: '已删除报价单',
        }
      }
      if (this.quotation.status == 5) {
        return {
          path: '/dashboard/done/quotations',
          name: '已转单报价单',
        }
      }
      return {
        path: '/dashboard/quotations',
        name: '进行中报价单',
      }
    },
  },
  watch: {
    keyword(newv) {
      this.search()
    },
  },
  mounted() {
    // var customerID = this.$route.query.customer_id
    // if (customerID) {
    //   this.addQuotationVisible = true
    //   this.quotation.customer = this.customers
    //     .filter(item => {
    //       return item.id == customerID
    //     })
    //     .shift()
    //   this.customerChange(customerID)
    // }
  },

  methods: {
    ready() {
      if (this.id > 0) {
        this.requestQuotation()
      }
    },
    async requestQuotation() {
      let res = await quotationDetail(this.id)
      if (res.code == 0) {
        if (res.data.approver_names) {
          res.data.approver_names_html = res.data.approver_names.join(
            ' <i class="el-icon-right"></i> '
          )
        }
        this.quotation = res.data
        this.recalculateItemFee()

        this.versions = this.quotation.versions.map((v, i) => {
          return {
            title: '历史版本 v' + (i + 1),
            version: v,
          }
        })
        this.versions.unshift({
          title: '当前版本',
          orderInfo: this.quotation.order_info,
        })
      }
    },
    async requestDeviceItemPackage(device, item) {
      let res = await itemDetail(item.id)
      let pk = {
        name: item.name + '明细',
        items: res.data.items,
      }
      device.packages.push(pk)

      let index = this.quotation.order_info.devices.indexOf(device)
      if (index >= 0) {
        this.quotation.order_info.devices.splice(index, 1, device)
      }
    },
    // recalculateItemFee() {
    //   this.displayFee = DisplayOrderFee(this.quotation.order_info)

    //   let that = this
    //   CalculateProfit(this.quotation.order_info, function(profit) {
    //     that.profit = profit
    //   })

    //   AutoOrderInfoFlow(this.quotation.order_info, null, function(
    //     orderInfoFlow
    //   ) {
    //     that.orderInfoFlow = orderInfoFlow
    //   })
    // },
    recalculateItemFee() {
      this.displayFee = DisplayOrderFee(this.quotation.order_info)

      let that = this

      CalculateProfit(this.quotation.order_info, function (profit, profitRate) {
        that.profit = profit
        that.profit_rate = profitRate
      })

      AutoOrderInfoFlow(
        this.quotation.order_info,
        this.oils,
        function (orderInfoFlow) {
          that.orderInfoFlow = orderInfoFlow
        }
      )
    },
    showParam(param, date) {
      if (param && param.length > 0) {
        if (date) {
          return formatTime(param)
        }
        return param
      } else {
        return '未设置'
      }
    },
    submitApproval() {
      let that = this
      this.$confirm('是否确定提交审批?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        submitApproveQuotation({ quotation_id: that.quotation.id }).then(
          (res) => {
            if (res.code == 0) {
              if (res.data.approver_names) {
                that.quotation.approver_names_html =
                  res.data.approver_names.join(
                    ' <i class="el-icon-right"></i> '
                  )
              }
              that.quotation.flow_id = res.data.flow.id
              that.quotation.flow = res.data.flow
              that.quotation.flow_name = res.data.flow_name
              that.quotation.approvers = res.data.approvers
              that.quotation.approve_index = 0
              that.quotation.approver_names = res.data.approver_names
              that.quotation.status = res.data.status
              that.$message({
                message: '提交成功',
                type: 'success',
              })
            }
          }
        )
      })
    },
    submitApprovalResult(result) {
      let that = this
      this.$confirm(
        '是否确定提交审批结果：' + (result ? '通过' : '不通过'),
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        approveQuotation({ id: that.quotation.id, result: result }).then(
          (res) => {
            if (res.code == 0) {
              that.quotation.status = res.data.status
              that.quotation.approve_index = res.data.approve_index
            }
          }
        )
      })
    },
    convertOrder() {
      let that = this
      this.$confirm('是否确定转化为订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        convertQuotation(that.quotation.id).then((res) => {
          if (res.code == 0) {
            that.quotation.status = res.data.status
            if (res.data.customer_order_id > 0) {
              that.$router.push(
                '/dashboard/dealer/orders/' + res.data.customer_order_id
              )
            }
          }
        })
      })
    },
    deleteQuotation() {
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteQuotation(that.quotation.id).then((res) => {
          if (res.code == 0) {
            that.quotation.deleted = 1
            that.$router.push(
              '/dashboard/deleted/quotations/' + that.quotation.id
            )
          }
        })
      })
    },
    recoveryQuotation() {
      let that = this
      this.$confirm('是否确定恢复?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        recoveryQuotation(that.quotation.id).then((res) => {
          if (res.code == 0) {
            that.quotation.deleted = 0
            that.$router.push('/dashboard/quotations/' + that.quotation.id)
          }
        })
      })
    },
    openQuotationVerions(index) {
      this.quotationVersionIndex = index + 1
      this.quotationVersionVisible = true
    },
    async selectedFlow(flow_id) {
      if (!flow_id || flow_id == 0) {
        return
      }
      let data = {
        quotation_id: this.quotation.id,
        flow_id: flow_id,
      }

      let res = await submitApproveQuotation(data)
      if (res.code == 0) {
        this.quotation.flow_id = res.data.flow_id
        this.quotation.flow = res.data.flow
        this.quotation.status = res.data.status
        this.$message({
          message: '提交成功',
          type: 'success',
        })
      }
    },
  },
}
</script>

<style scoped>
.order-option-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
/deep/.el-form-item--mini {
  margin-bottom: 0px;
}
/deep/.el-form-item--mini .el-form-item__label,
/deep/.el-form-item--mini .el-form-item__content {
  font-size: 13px;
}
.q-info p {
  font-size: 14px;
  color: #333;
  margin: 0 0 10px 0;
}
.q-info p span {
  margin-left: 2em;
}

.q-info {
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

h3 {
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}

.q-products {
  background-color: #dae1f2;
}

.q-products .title {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.total {
  margin-top: 10px;
  overflow: hidden;
}

.total .row {
  width: 100%;
  clear: both;
}

.total .row span {
  width: 120px;
  padding: 12px 10px;
  box-sizing: border-box;
}

.total .row span.title {
  width: 110px;
  color: #909399;
}

.info-form .el-form-item {
  margin-top: 10px;
  margin-bottom: 0;
}
.del-device {
  border: 0 none;
  background: #fff;
}
.other-infos {
  line-height: 1.8;
}
.other-infos li.sub-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.other-infos li.sub-info .sub-info-label {
  font-size: 14px;
  width: 100px;
}

.other-infos li.sub-info .sub-info-value {
  flex: 1;
  text-align: right;
}
.versions li {
  padding-bottom: 10px;
  margin-top: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.versions li:last-child {
  border-bottom: 0 none;
  padding-bottom: 0;
}
.customer-info .sub-info {
  border-top: 0 none;
}

.customer-link {
  position: absolute;
  right: 20px;
  top: 20px;
}
.sub-info-label {
  margin-right: 1em;
}
</style>